import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository, type DriverLocationParams } from '../infra/ShipmentRepository'

export type AddDriverLocationDependencies = {
  repository: ShipmentRepository
}

export function addDriverLocationFactory({ repository }: AddDriverLocationDependencies) {
  return async function addDriverLocationManually(params: DriverLocationParams) {
    try {
      return await repository.addDriverLocation(params)
    } catch (error) {
      throw new Error('Failed to add location, please try again', { cause: error as Error })
    }
  }
}

export function addDriverLocation(params: DriverLocationParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const addDriverLocationManually = addDriverLocationFactory({ repository })

  return addDriverLocationManually(params)
}
